import { helpers } from '@pt/utilities';
export default {
  getByField: state => field => helpers.fetchFromObject(state, field)
};
